import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ce0565a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "fixed-top-player-box" }
const _hoisted_4 = ["id"]

import { onDeactivated, reactive } from 'vue'
import { Toast } from 'vant'
import { getVideoPlayVoucher } from '@/api/video/'

export default /*#__PURE__*/_defineComponent({
  __name: 'MPopupPlayer',
  props: {
  vid: String,
  emptyTips: {
    default: '该企业暂未上传企业影片',
    type: String,
  },
  skinLayout: {
    default: [
      { name: 'infoDisplay', align: 'cc' },
      { name: 'errorDisplay', align: 'tlabs', x: 0, y: 0 },
      {
        name: 'controlBar',
        align: 'blabs',
        x: 0,
        y: 0,
        children: [
          { name: 'playButton', align: 'tl', x: 0, y: 10 },
          { name: 'timeDisplay', align: 'tl', y: 2 },
          { name: 'progress', align: 'tl' },
          { name: 'fullTimeDisplay', align: 'tl' },
          // { name: 'volume', align: 'tl', x: 0, y: 10 },
          // { name: 'setting', align: 'tl', x: 0, y: 10 },
          { name: 'fullScreenButton', align: 'tr', x: 0, y: 10 },
        ],
      },
    ],
  },
},
  setup(__props, { expose }) {

const props = __props;



const state = reactive({
  isShowVideo: false,
  playobj: null,
  playerData: null,
  timer: 0,
  playerId: `player-${Date.now()}`,
})

// 打开影片
const openVideo = async () => {
  if (!props.vid) {
    Toast(props.emptyTips)
    return false
  }
  initPlayer()
  state.isShowVideo = true
}

const initPlayer = async () => {
  const videoId = props.vid?.replace('\n', '')
  const resp = await getVideoPlayVoucher({ videoId })
  const opt = {
    id: state.playerId, // 容器id
    autoplay: true, // 自动播放
    width: '100%', // 播放器宽度
    height: '100%', // 播放器高度
    isLive: false,
    preload: true,
    useH5Prism: true,
    controlBarVisibility: 'click',
    mediaType: 'video',
    rePlay: true, // 循环播放
    showBarTime: 60000,
    vodRetry: 3,
    playauth: resp.data.playAuth,
    vid: videoId,
    x5_video_position: 'center', //声明视频播在界面上的位置 “top”，“center”
    x5_fullscreen: false, //声明视频播放时是否进入到TBS的全屏模式，支持的值为true。
    // x5_orientation:"portraint",//声明TBS播放器支持的方向，取值：landscape：横屏。portraint：竖屏。
    // x5_type:'h5', //启用同层播放，设置值为h5
    // playsinline:"false",//启用同层播放
    skinLayout: props.skinLayotu,
  }
  const Aliplayer = window?.Aliplayer
  new Aliplayer(opt, (player: any) => {
    state.playobj = player
    if (window.WeixinJSBridge) {
      doPlay()
    } else {
      document.addEventListener('WeixinJSBridge', doPlay, false)
    }
    state?.player?.play()
  })
}

const doPlay = () => {
  window?.WeixinJSBridge.invoke('getNetworkType', {}, () => {
    if (state.isShowVideo) state.playobj?.play()
  })
}

const disposePlayer = () => {
  state.isShowVideo = false
  state.playobj?.dispose()
  state.playobj = null
}

const closePopPlayer = () => {
  disposePlayer()
}

onDeactivated(() => {
  disposePlayer()
})
expose({
  closePopPlayer,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      onClick: _withModifiers(openVideo, ["stop"])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 8, _hoisted_1),
    (state.isShowVideo)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed-top-player-pop",
          onClick: _withModifiers(closePopPlayer, ["stop"])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "player-box fixed-top-player",
              id: state.playerId
            }, null, 8, _hoisted_4)
          ])
        ], 8, _hoisted_2))
      : _createCommentVNode("", true)
  ], 64))
}
}

})